import { Chip } from 'bricks-ui/packages/bricks-ui';

export default Chip;
